import { Image } from "@tiptap/extension-image";
import {
  NodeViewProps,
  NodeViewWrapper,
  ReactNodeViewRenderer,
} from "@tiptap/react";
import ArticleImage from "../ArticleImage/ArticleImage";

const ArticleImageNodeView = ({
  node,
  updateAttributes,
  deleteNode,
}: NodeViewProps) => {
  const { src, alt } = node.attrs;

  const setImage = ({ id, alt }: { id: string; alt: string }) => {
    updateAttributes({
      src: `${import.meta.env.VITE_IMAGE_HOST}/${id}#${id}`,
      alt,
    });
  };

  let imageUrl;
  let imageId;

  if (src && typeof src === "string") {
    try {
      imageUrl = new URL(src);
      imageId = imageUrl.hash.replace("#", "");
    } catch {
      // Empty catch
    }
  }

  if (src && typeof src === "string" && !imageId) {
    return (
      <NodeViewWrapper
        as="img"
        src={src}
        alt={typeof alt === "string" ? alt : undefined}
      />
    );
  }

  return (
    <NodeViewWrapper>
      <ArticleImage id={imageId} setImage={setImage} onDelete={deleteNode} />
    </NodeViewWrapper>
  );
};

const CustomImage = Image.extend({
  draggable: false,

  addNodeView() {
    return ReactNodeViewRenderer(ArticleImageNodeView);
  },
});

export default CustomImage;
